import { gql } from 'graphql-request';
import { graphQLFragments } from 'shared/graphql/fragments';

const bookClubs = gql`
  query fetchBookClubs($page: Int, $pageSize: Int) {
    bookClubs {
      objects(page: $page, pageSize: $pageSize) {
        ... on BookClub {
          displayName
          featuredImageCloudinaryImageId
          hostName
          id
          shortDescription
          url
        }
      }
    }
  }
`;

const bookClubAudiobook = gql`
  ${graphQLFragments.productShape}
  ${graphQLFragments.audiobookUserAudiobookPlayableShape}
  query fetchBookClubAudiobook($bookClubId: ID!, $audiobookId: ID!) {
    bookClub(id: $bookClubId) {
      displayName
      hostImageCloudinaryImageId
      hostName
      url

      bookClubAudiobook(audiobookId: $audiobookId) {
        displayTimeframe
        hostBlurb

        additionalLinks {
          label
          url
        }

        audiobook {
          averageRating
          description
          coverUrl
          displayTitle
          fitForSale
          futureSaleDate
          id
          ratingsCount
          runtime
          url

          ...audiobookUserAudiobookPlayableFields

          allAuthors {
            name
            slug
            url
          }

          allNarrators {
            name
            slug
            url
          }

          colorPalette {
            mediumShade
            darkShade
            darkestShade
          }

          currentProduct {
            salableInCurrentCountry
            limitedTimeOffer
            ...productFields
          }

          promotedTags {
            displayName
            id
            url
          }
        }
      }
    }
  }
`;

const bookClubAudiobooks = gql`
  query fetchBookClubAudiobooks(
    $bookClubId: ID!
    $omitAudiobookIds: [ID!]
    $page: Int
    $pageSize: Int
    $publishedOnly: Boolean
  ) {
    bookClub(id: $bookClubId) {
      bookClubAudiobooks(omitAudiobookIds: $omitAudiobookIds, publishedOnly: $publishedOnly) {
        objects(page: $page, pageSize: $pageSize) {
          ... on BookClubAudiobook {
            id
            hostBlurb
            displayTimeframe
            path
            audiobook {
              id
              coverUrl
              displayTitle
              displayAuthors
              colorPalette {
                mediumShade
                darkShade
                darkestShade
              }
            }
          }
        }
      }
    }
  }
`;

const bookClubCurrentPick = gql`
  query fetchBookClubCurrentPick($bookClubId: ID!) {
    bookClub(id: $bookClubId) {
      hostName

      currentBookClubAudiobook {
        displayTimeframe
        path

        audiobook {
          id
          coverUrl
          allAuthors {
            name
            slug
            url
          }
          displayAuthors
          displayTitle
          url

          colorPalette {
            mediumShade
            darkShade
            darkestShade
          }

          currentProduct {
            salableInCurrentCountry
            showListingPrice
            limitedTimeOffer
            listingPrice
            discountPrice
            isFreeListing
            purchaseUrl
            timeLeft
          }
        }
      }
    }
  }
`;

export const bookClubQueries = {
  bookClubs,
  bookClubAudiobook,
  bookClubAudiobooks,
  bookClubCurrentPick,
};
